import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_LIST = (query) => {
  const params = querystring.stringify(query);
  return axiosIns.get(`/t/api/v1/get?${params}`);
};

export const GET_DETAIL = ({ id, query }) => {
  const params = querystring.stringify(query);
  return axiosIns.get(`/t/api/v1/detail/${id}?${params}`);
};

export const GET_LOGS = ({ id, query }) => {
  const params = querystring.stringify(query);
  return axiosIns.get(`/t/api/v1/detail/${id}/logs?${params}`, id);
};

export const CREATE_DATA = (payload) => {
  return axiosIns.post(`/t/api/v1/create`, payload);
};

export const UPDATE_DATA = (id, payload) => {
  return axiosIns.put(`/t/api/v1/update/${id}`, payload);
};

export const REMOVE_DATA = ({ id, query }) => {
  const params = querystring.stringify(query);
  return axiosIns.delete(`/t/api/v1/remove/${id}?${params}`);
};
